import 'css-chunksrc/client/common/preview/defaultRenderer/styles.scss';export default {
  "renderer": "_renderer_kvt48_1"
};